<template>
  <div class="content-container">
    <div class="flex column flex-1">
      <div v-loading="loading" class="flex-1 w-100">
        <GridEnterprise
          ref="agGrid"
          :columns="columnDefs"
          dom-layout="scroll"
          :rows="rowData"
          class="agGrid"
          :group-grid="true"
          :tree-data="true"
          :default-col-def="defaultColDef"
          :group-use-entire-row="false"
          :auto-group-column-def="autoGroupColumnDef"
          :get-data-path="getDataPath"
          @selectionChanged="rowSelectionChanged"
        />
      </div>
    </div>
    <div class="button-containers mb-0">
      <button
        class="btn primary small outline"
        :disabled="selectedRows.length == 0"
        @click="deleteProductCategory"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        class="btn primary small"
        :disabled="selectedRows.length == 0"
        @click="editProductCategory"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="openDialog">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="
        isEdit
          ? $t('dialog.productCategoryUpdate')
          : $t('dialog.productCategoryAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      class="over-inherit"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.mainCategory') }}:</div>
                  <div class="child-w-80">
                    <VxTreeSelect
                      :options-tree="optionsTree"
                      :parent-data="productCategoryItem.main_category_id"
                      @valueChange="treeValueChange"
                    />
                  </div>
                </div>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="required|max:20" name="Mã danh mục">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.codeCategory') }}:
                    </div>
                    <div class="child-w-80">
                      <input
                        v-model="productCategoryItem.code"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:50"
                  name="Tên tiếng Việt"
                >
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.viName') }}:</div>
                    <div class="child-w-80">
                      <input v-model="productCategoryItem.name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:50"
                  name="Tên tiếng Anh"
                >
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.enName') }}:</div>
                    <div class="child-w-80">
                      <input
                        v-model="productCategoryItem.eng_name"
                        type="text"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.target') }}:</div>
                  <!-- <div class="child-w-80">
                    <select v-model="productCategoryItem.target_id">
                      <option
                        v-for="item in targetOptions"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.desc }}
                      </option>
                    </select>
                  </div> -->
                  <select-with-search-table
                    style="width: 100%"
                    :rows="targetOptions"
                    :columns="selectSearchCol1"
                    :search-fields="['code']"
                    :value="productCategoryItem.target_id"
                    :selected-index-field-value="productCategoryItem.target_id"
                    index-field="id"
                    @selectionChanged="onSelectRowOption1"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.code }}
                    </template>
                  </select-with-search-table>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">{{ $t('dialog.serviceType') }}:</div>
                  <select-with-search-table
                    style="width: 100%"
                    :rows="serviceTypeOptions"
                    :auto-size-cell="true"
                    :columns="selectSearchCol2"
                    :search-fields="['code']"
                    :value="productCategoryItem.service_type_id"
                    :selected-index-field-value="
                      productCategoryItem.service_type_id
                    "
                    index-field="id"
                    @selectionChanged="onSelectRowOption2"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.code }}
                    </template>
                  </select-with-search-table>
                  <!-- <div class="child-w-80">
                    <select v-model="productCategoryItem.service_type_id">
                      <option
                        v-for="item in serviceTypeOptions"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.desc }}
                      </option>
                    </select>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateProductCategory"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addProductCategory">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import VxTreeSelect from '@/components/ui/VxTreeSelect.vue'
import { getServiceTypeListApi } from '@/api/common/code'
import { getListTarget } from '@/api/common/code_base'
import { removeItemByName } from '@/vendor/subFunctions'
import {
  getListProductCategoryApi,
  addProductCategoryApi,
  updateProductCategoryApi,
  deleteProductCategoryApi
} from '@/api/configuration/accounting/product/productCategory.js'
import { Message } from 'element-ui'
export default {
  components: {
    VxTreeSelect
  },
  data() {
    return {
      selectedRows: [],
      selectSearchCol1: [
        {
          headerName: 'Mục tiêu',
          field: 'code',
          flex: 1
        }
      ],
      selectSearchCol2: [
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          flex: 1
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          tooltipField: 'desc',
          flex: 1
        }
      ],
      // treeData: null,
      optionsTree: [],
      dfOptionsTree: [],
      rowData: [],
      targetOptions: [],
      serviceTypeOptions: [],
      columnDefs: [],
      defaultColDef: [],
      loading: false,
      // columns: [],
      rowId: null,
      rows: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {},
      productCategoryItem: {
        id: null,
        main_category_id: null,
        code: '',
        name: '',
        eng_name: '',
        target_id: null,
        service_type_id: null
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.defaultColDef = { flex: 1 }
    this.context = { componentParent: this }
    this.columnDefs = [
      {
        headerName: this.$t('grid.column.viName'),
        valueGetter: function (params) {
          return params.data.name
        }
      },
      {
        headerName: this.$t('grid.column.enName'),
        valueGetter: function (params) {
          return params.data.engName
        }
      },
      {
        headerName: this.$t('grid.column.target'),
        valueGetter: function (params) {
          return params.data.targetName
        }
      },
      {
        headerName: this.$t('grid.column.serviceType'),
        valueGetter: function (params) {
          return params.data.serviceTypeName
        }
      }
    ]
    this.autoGroupColumnDef = {
      headerName: this.$t('grid.column.categoryCode'),
      // headerCheckboxSelection: true,
      cellRendererParams: {
        checkbox: false,
        // innerRenderer: true,
        // minWidth: 300,
        suppressCount: true
        // suppressCount: true,
        // checkbox: (params) => {
        //   return params.node.level === 0
        // },
        // innerRenderer: (params) => {
        //   return params.data.package_code
        // }
      }
    }
    this.getDataPath = data => {
      return data.code
    }
  },
  async mounted() {
    const res = await getServiceTypeListApi()
    const res2 = await getListTarget()
    this.serviceTypeOptions = res.data
    this.targetOptions = res2.data
    this.attachData()
  },
  methods: {
    rowSelectionChanged(row) {
      this.selectedRows = row
    },
    // removeItemByName(arr, targetName) {
    //   for (let i = 0; i < arr.length; i++) {
    //     if (arr[i].name === targetName) {
    //       arr.splice(i, 1) // Remove the current object if it has the target ID
    //       return
    //     }

    //     if (arr[i].children && arr[i].children.length > 0) {
    //       this.removeItemByName(arr[i].children, targetName) // Recursively check children
    //       if (arr[i].children.length === 0) {
    //         delete arr[i].children // Remove the "children" property if it becomes empty
    //       }
    //     }
    //   }
    // },
    onSelectRowOption1(val) {
      this.productCategoryItem.target_id = val.id
    },
    onSelectRowOption2(val) {
      this.productCategoryItem.service_type_id = val.id
    },
    treeValueChange(data) {
      this.productCategoryItem.main_category_id = data
    },
    changeKeyNames(obj) {
      // Base case: if the object is not an array or an object, return it as is
      if (!obj || typeof obj !== 'object') {
        return obj
      }

      // If the object is an array, iterate over its elements
      if (Array.isArray(obj)) {
        return obj.map(item => this.changeKeyNames(item))
      }

      // If the object is an object, iterate over its key-value pairs
      const newObj = {}
      for (const key in obj) {
        // Change the key from 'code' to 'label'
        const newKey = key === 'code' ? 'label' : key
        const newKey1 = key === 'main_category_id' ? 'id' : key
        // Change the key from 'sub_transactions' to 'children'
        // Recursively process the value
        newObj[newKey] = this.changeKeyNames(obj[key])
        newObj[newKey1] = this.changeKeyNames(obj[key])
      }
      return newObj
    },
    flattenNestedArray(arr, parentCodes = []) {
      return arr.flatMap(item => {
        const currentCodes = [...parentCodes, item.code]
        const flattenedItem = {
          code: currentCodes,
          name: item.name,
          id: item.id,
          mainCategoryId: item.mainCategoryId,
          engName: item.engName,
          targetName: item.targetName,
          serviceTypeName: item.serviceTypeName,
          targetId: item.targetId,
          serviceTypeId: item.serviceTypeId
        }

        if (item.children) {
          return [
            flattenedItem,
            ...this.flattenNestedArray(item.children, currentCodes)
          ]
        } else {
          return [flattenedItem]
        }
      })
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    resetInfo() {
      // this.treeData = null
      this.isEdit = false
      this.productCategoryItem = {
        id: null,
        main_category_id: null,
        code: '',
        name: '',
        eng_name: '',
        target_id: null,
        service_type_id: null
      }
    },
    openDialog() {
      this.dialogFormVisible = true
      Object.assign(this.optionsTree, this.dfOptionsTree)
    },
    // table controller
    onRowClick(index) {
      document.getElementById(`currency-${index}`).classList.add('row-focus')
      if (this.rowId != null) {
        document
          .getElementById(`currency-${this.rowId}`)
          .classList.remove('row-focus')
      }
      this.rowId = index
    },
    // CRUD
    async addProductCategory() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addProductCategoryApi(this.productCategoryItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editProductCategory() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      this.isEdit = true
      this.dialogFormVisible = true
      this.productCategoryItem.id = row.id
      // this.productCategoryItem.main_category_id = row.mainCategoryId
      let array = []
      array = JSON.parse(JSON.stringify(this.dfOptionsTree))
      // remove elements
      removeItemByName(array, row.name)
      this.optionsTree = array
      setTimeout(() => {
        this.productCategoryItem.main_category_id = row.mainCategoryId
      }, 200)
      this.productCategoryItem.code = row.code[row.code.length - 1]
      this.productCategoryItem.name = row.name
      this.productCategoryItem.eng_name = row.engName
      this.productCategoryItem.target_id = row.targetId
      this.productCategoryItem.service_type_id = row.serviceTypeId
    },
    async deleteProductCategory() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      const id = row.id
      const id_list = []
      id ? id_list.push(id) : null
      if (id_list.length == 0) {
        this.$alert('Bạn chưa chọn loại danh mục!', 'Error', {
          confirmButtonText: 'OK'
        })
      } else {
        this.$vxConfirm('Bạn chắc chắn muốn xoá loại danh mục này?', () => {
          deleteProductCategoryApi({
            id_list: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    async updateProductCategory() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateProductCategoryApi(this.productCategoryItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListProductCategoryApi(this.searchParams)
      this.dfOptionsTree = this.changeKeyNames(data.data)
      this.rowData = this.flattenNestedArray(data.data)
      this.loading = false
      this.rows = data.data
      this.selectedRows = []
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
